import type { ServerColDef } from '@cmg/data-grid';

import type { InvestorFirmFragment } from '../graphql/__generated__';

export const factSetColDef: ServerColDef<InvestorFirmFragment> = {
  field: 'factSet',
  headerName: 'FactSet',
  initialHide: true,
};
